// extracted by mini-css-extract-plugin
module.exports = {"cards":"ArticlePageRecommend_cards__p_fQj","cardsInner":"ArticlePageRecommend_cardsInner__PBLVw","card":"ArticlePageRecommend_card__XRyqj"};